import Button from 'components/Button'
import { View } from 'components/View'
import React from 'react'
import { ArrowDownIcon } from 'components/Icon/icons/arrow-down/index.js'
import TextTitleCondensed from 'components/TextTitleCondensed.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import getActionStrReduxUtil from 'modules/redux/utils/get-action-str/index.js'

const ANALYTIC_EVENT_PREFIX = {
  SHOW: 'SHOW',
  HIDE: 'HIDE'
}

/**
 * @param onClick
 * @param children
 * @param label
 * @param isOpen
 * @param numberOfLines
 * @returns {JSX.Element}
 * @constructor
 */
export default function Collapsible ({
  onClick,
  label,
  children,
  isOpen = false,
  numberOfLines = 2
}) {
  const [isOpenState, setIsOpenState] = React.useState(isOpen)

  const handleClick = () => {
    const newValue = !isOpenState
    setIsOpenState(newValue)
    onClick?.(newValue)

    const formattedLabel = getActionStrReduxUtil(label)
    const analyticEvent = getActionStrReduxUtil(ANALYTIC_EVENT_PREFIX[newValue ? 'SHOW' : 'HIDE'], formattedLabel)
    logEventAnalyticsUtil(analyticEvent)
  }

  return (
    <View>
      <Button
        isFullWidth
        style={{
          height: 'unset',
          maxWidth: 'unset'
        }}
        onClick={handleClick}
      >
        <View
          row
          style={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            width: '100%'
          }}
        >
          <TextTitleCondensed
            mr
            numberOfLines={numberOfLines}
            c='#151D21'
            style={{
              'text-align': 'left'
            }}
          >
            {label}
          </TextTitleCondensed>

          <ArrowDownIcon
            style={{
              transform: isOpenState
                ? 'rotate(180deg)'
                : 'rotate(0deg)',
              transition: '1s'
            }}
          />
        </View>
      </Button>
      {isOpenState && children}
    </View>
  )
}
